<template>
  <div class="layout-center-wrap">
    <!-- 상단 타이틀 -->
    <section class="page-tit__wrap">
      <h1 class="page-tit__sub">KNVD 소개</h1>
      <p class="page-tit">핵더챌린지 분석플랫폼</p>
    </section>
    <section class="section-pt">
      <!-- 개요 -->
      <article class="">
        <h2 class="section-title">개요</h2>
        <p class="description__content">
          신규 보안취약점 신속 발굴 및 조치를 위해 보안전문가들의 집단지성을
          활용한 클라우드 기반의 핵더챌린지 분석플랫폼 구축
          <br />
          중앙관리SW, 출시 전 제품, 홈페이지 등 취약점발굴이 어려운 SW를
          클라우드 서버에 설치 후 보안전문가에게 제공하여 신규 취약점 발굴
        </p>
        <figure class="diagram-area" aria-hidden="true">
          <picture class="light-only">
            <!-- 모바일용 -->
            <source
              srcset="@/assets/img/intro/img_platform_flow_m.png"
              media="(max-width: 767.9px)"
            />
            <!-- 태블릿용 -->
            <source
              srcset="@/assets/img/intro/img_platform_flow_tb.png"
              media="(max-width: 1399.9px)"
            />
            <!-- PC용 -->
            <img src="@/assets/img/intro/img_platform_flow.png" alt="" />
          </picture>
          <picture class="dark-only">
            <!-- 모바일용 -->
            <source
              srcset="@/assets/img/intro/img_platform_flow_m_dark.png"
              media="(max-width: 767.9px)"
            />
            <!-- 태블릿용 -->
            <source
              srcset="@/assets/img/intro/img_platform_flow_tb_dark.png"
              media="(max-width: 1399.9px)"
            />
            <!-- PC용 -->
            <img src="@/assets/img/intro/img_platform_flow_dark.png" alt="" />
          </picture>
          <div class="text-hidden">
            <div>
              <h2>매칭 -></h2>
              <ul>
                <li>ICT 제품 개발기업</li>
                <li>신규 보안취약점 정보공유</li>
                <li>보안취약점 신속 패치 제공</li>
                <li>민간 보안전문가</li>
                <li>신규 취약점 발굴. 신고</li>
                <li>최신 취약점 정보 공유</li>
              </ul>
              <h2>핵더챌린지 분석플랫폼 -></h2>
              <ul>
                <li>민간기업</li>
                <li>신규 취약점 보안패치 개발지원</li>
                <li>백신업데이트 등 피해확산 방지</li>
                <li>일반국민</li>
                <li>보안취약점동향, 예방조치 방안 등</li>
                <li>각종 취약점 정보 온라인 제공</li>
              </ul>
            </div>
          </div>
        </figure>
      </article>
      <!-- 주요 내용 -->
      <article class="description">
        <h2 class="section-title">주요 내용</h2>
        <div class="description__content">
          <p>(분석대상 SW 개방)</p>
          <p>
            클라우드 기반의 서버제공으로 분석대상 SW를 사전 설치 후 민간
            보안전문가에게 개방
          </p>
          <p>
            ※ 분석대상 SW 설치 시 기업의 취약점 분석 동의 후 민간 보안전문가에게
            개방
          </p>
        </div>
        <div class="description__content">
          <p>(취약점 발굴)</p>
          <p>
            민간보안전문가에게 취약점 분석환경이 구성된 가상데스크톱을 제공하여
            분석대상 SW의 신규 취약점 발굴 진행
          </p>
          <p>
            ※ 취약점 분석 환경에 대한 로그 관리, 정보 유출 방지 등 강화된 보안
            관리 기능
          </p>
        </div>
      </article>
    </section>
  </div>
</template>